const social = 
[
        {
            "id": 1,
            "alt": "instagram",
            "titulo": "Instagram",
            "link":'https://www.instagram.com/estudioindex/'
        },{
            "id": 6,
            "alt": "linkedin",
            "titulo": "Linkedin",
            "link":'https://www.linkedin.com/company/estudioindex/'
        },{
           "id": 2,
            "alt": "facebook",
            "titulo": "Facebook",
            "link":'https://www.instagram.com/estudioindex/'
        },{
            "id": 3,
            "alt": "spotify",
            "titulo": "Spotify",
            "link":'https://www.instagram.com/estudioindex/'
        },{
            "id": 4,
            "alt": "twitter",
            "titulo": "Twitter",
            "link":'https://www.instagram.com/estudioindex/'
        },{
            "id": 5,
            "alt": "pinterest",
            "titulo": "Pinterest",
            "link":'https://www.instagram.com/estudioindex/'
        }
]
export default social